class CurifyException extends Error {
    constructor(message) {
        super(message);
        this.name = "CurifyException";
    }
}

class APIError extends CurifyException {
    constructor(statusCode, message) {
        super(`API Error ${statusCode}: ${message}`);
        this.statusCode = statusCode;
    }
}

module.exports = { CurifyException, APIError };
